import { all } from 'redux-saga/effects';
import { onBasketError, onDealFinderTokenExpired, onLocationChange } from '@state/modal/modalOperations';

export function* combinedModalSagas() {
  yield all([onBasketError(), onLocationChange(), onDealFinderTokenExpired()]);
}
